import React, { useCallback, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import axios from "axios";
import Cookies from "js-cookie";
import { NODE_API_URL, BASE_URL, CCMODE_BASE_URL } from "../../../env_config";
import confetti from "canvas-confetti";
import { Grid } from "@material-ui/core";
import CCModeGif from "./../../../assets/images/ccmode.gif";
import celebrationImg from "./../../../assets/images/celebration.png";
import { ReactComponent as CustomBrandingSVG } from "./../../../assets/images/customizeBranding.svg";
import { ReactComponent as MultiCurrencySVG } from "./../../../assets/images/multiCurrency.svg";
import { ReactComponent as SetMarkupPriceSVG } from "./../../../assets/images/setMarkupPrice.svg";
import { FaLink } from "react-icons/fa6";
import { MdClose } from "react-icons/md";

const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
};

export const CongratulateCCModeDashboardPopUp = ({
    show,
    setShow,
    language,
    ccmodesetting,
}) => {
    const showConfetti = () => {
        const end = Date.now() + 1.5 * 1000; // 3 seconds
        const colors = ["#a786ff", "#fd8bbc", "#eca184", "#f8deb1"];

        const frame = () => {
            if (Date.now() > end) return;

            confetti({
                particleCount: 2,
                angle: 60,
                spread: 55,
                startVelocity: 60,
                origin: { x: 0, y: 0.5 },
                colors: colors,
            });
            confetti({
                particleCount: 2,
                angle: 120,
                spread: 55,
                startVelocity: 60,
                origin: { x: 1, y: 0.5 },
                colors: colors,
            });

            requestAnimationFrame(frame);
        };

        frame();
    };

    useEffect(() => {
        if (show) {
            showConfetti();
        }
    }, [show]);

    // memoized API call
    const markCongratulationPopUpSeen = useCallback(async () => {
        try {
            await axios.post(
                `${NODE_API_URL}/INTL/seen-dashboard-popup`,
                {
                    source: "ccmode" 
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get(
                            "cust_auth_token"
                        )}`,
                    },
                }
            );
            // you could check data.success here if needed
        } catch (error) {
            if (error.response?.data?.message === "UnAuthorized!") {
                document.cookie.split(";").forEach((c) => {
                    if (!c.includes("view")) {
                        const name = c.split("=")[0].trim();
                        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
                    }
                });
                window.location.replace(`${BASE_URL}/logout`);
            }
        }
    }, []);

    // single close handler
    const handleClose = useCallback(() => {
        setShow(false);
        markCongratulationPopUpSeen();
    }, [setShow, markCongratulationPopUpSeen]);


    async function handleCCModeBtn() {
        try {
        const res = await axios({
            method: "GET",
            url: `${NODE_API_URL}/INTL/generate-auto-login-token`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        });

        if (res && res.data && res.data.success) {
            const token = res.data.token;
            console.log(ccmodesetting);
            const clientURL = `${ccmodesetting.client_domain || CCMODE_BASE_URL}?autoLoginToken=${encodeURIComponent(
                token
            )}`;
            window.open(clientURL, "_blank");
        }
        } catch (error) {
            if (error?.response?.data?.message === "UnAuthorized!") {
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                    if (cookies[i] && !cookies[i].includes("view")) {
                        var equals = cookies[i].indexOf("=");
                        var name =
                            equals > -1
                                ? cookies[i].substr(0, equals)
                                : cookies[i];
                        document.cookie =
                            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                }
                window.location.replace(`${BASE_URL}/logout`);
            }
        }
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header className="justify-content-center text-capitalize">
                <Modal.Title>
                    <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ gap: "2rem" }}
                    >
                        <img
                            src={celebrationImg}
                            alt="celebration"
                            width={40}
                            style={{ transform: "scaleX(-1)" }}
                        />
                        <span className="font-size-h1">{`Welcome, ${ccmodesetting.displayName}`}</span>
                        <img
                            src={celebrationImg}
                            alt="celebration"
                            width={40}
                        />
                        <MdClose
                            style={{
                                fontSize: "32px",
                                position: "absolute",
                                top: "24px",
                                right: "24px",
                                cursor: "pointer",
                            }}
                            onClick={handleClose}
                        />
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PerfectScrollbar
                    options={perfectScrollbarOptions}
                    className="scroll"
                    style={{ maxHeight: "600px", position: "relative" }}
                >
                    <div id="terms-body" className="row m-0">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <p className="text-center font-size-h6">
                                    Your <b>CC Mode Dashboard</b> is now live with default settings.
                                </p>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <img
                                        src={CCModeGif}
                                        alt="CCMode Gif"
                                        style={{ width: "100%" }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div>
                                        <div className="d-flex align-items-center mb-2">
                                            <CustomBrandingSVG
                                                style={{
                                                    width: "38px",
                                                    height: "38px",
                                                }}
                                            />
                                            <span className="ml-6 font-size-h4 font-weight-bold">
                                                Custom Branding
                                            </span>
                                        </div>
                                        <div className="d-flex align-items-center mb-2">
                                            <SetMarkupPriceSVG
                                                style={{
                                                    width: "38px",
                                                    height: "38px",
                                                }}
                                            />
                                            <span className="ml-6 font-size-h4 font-weight-bold">
                                                Multi-Currency Display
                                            </span>
                                        </div>
                                        <div className="d-flex align-items-center mb-2">
                                            <MultiCurrencySVG
                                                style={{
                                                    width: "38px",
                                                    height: "38px",
                                                }}
                                            />
                                            <span className="ml-6 font-size-h4 font-weight-bold">
                                                Multi-Level Markups
                                            </span>
                                        </div>
                                        <p className="font-size-h6 mt-4">We’ve applied the default configuration, but you can customize settings anytime to match your preferences.</p>
                                        <div>
                                        <span className="font-size-h1 mr-4">👉</span>
                                        <Button
                                            className="font-size-h4 my-6"
                                            // href={
                                            //     ccmodesetting.client_domain ||
                                            //     CCMODE_BASE_URL
                                            // }
                                            onClick={handleCCModeBtn}
                                        >
                                            Access CCMode Portal{" "}
                                            <FaLink className="ml-2 font-size-h4" />
                                        </Button><br></br><span className="font-size-h6">Or log in using your existing account credentials.</span>
                                        </div>
                                        <br></br>
                                        <p className="font-size-h6">
                                            For assistance, feel free to reach out to your <b>account executive.</b>
                                        </p>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </PerfectScrollbar>
            </Modal.Body>
        </Modal>
    );
};
